// extracted by mini-css-extract-plugin
export var actionText = "_jw-4";
export var container = "_jw-0";
export var leftSection = "_jw-1";
export var rightSection = "_jw-2";
export var settingsButton = "_jw-6";
export var settingsIcon = "_jw-7";
export var shortcut = "_jw-5";
export var shortcutGroup = "_jw-3";